module.exports = __webpack_public_path__ + "static/media/start-buying-info2.a65d2d8e.png";